import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Handshake, Scale, ShieldCheck } from 'lucide-react';
const values = [{
  title: 'Gebündelte Expertise',
  icon: Handshake
}, {
  title: 'Höchste Präzision',
  icon: Scale
}, {
  title: 'Kompromisslose Qualität',
  icon: ShieldCheck
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ManifestoPanel() {
  return <section className="w-full bg-petrol text-white py-24 relative overflow-hidden" data-id="element-188">
      {/* Large background numeral */}
      <div className="absolute -top-10 -right-10 text-[20rem] font-extrabold text-hoefelmeyer-green opacity-5 leading-none select-none pointer-events-none" data-id="element-189">
        01
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-191">
          <div className="flex items-center gap-4 mb-6" data-id="element-192">
            <span className="text-hoefelmeyer-green font-bold text-xl" data-id="element-193">01</span>
            <div className="h-px w-12 bg-hoefelmeyer-green" data-id="element-194"></div>
            <span className="text-sm uppercase tracking-widest text-slate-400 font-medium" data-id="element-195">
              Manifesto
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight" data-id="element-196">
            Warum diese Partnerschaft.
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-197">
          {values.map((value, index) => {
          const Icon = value.icon;
          return <motion.div key={index} variants={itemVariants} className="flex flex-col" data-id="element-198">
                <div className="w-12 h-12 border border-hoefelmeyer-green flex items-center justify-center mb-6 bg-petrol-dark" data-id="element-199">
                  <Icon className="text-hoefelmeyer-green" size={24} strokeWidth={1.5} data-id="element-200" />
                </div>
                <h3 className="text-xl font-bold text-white" data-id="element-201">{value.title}</h3>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}